import React from "react";
import { Box, InputAdornment, TextField, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
import { CalenderIcon } from "../../../common/Icons/Icons";

const BasicDatePicker = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Date Picker
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"Browser Default Date picker in basic outlined TextField."}
          language={"js"}
          value={
            "           <TextField\n" +
            '                label={"Don\'t send any messages before"}\n' +
            '                type={"date"}\n' +
            '                // value="2023-08-27"\n' +
            "                InputProps={{\n" +
            "                  endAdornment: (\n" +
            '                      <InputAdornment position="end">\n' +
            '                        <CalenderIcon fontSize={"small"} />\n' +
            "                      </InputAdornment>\n" +
            "                  ),\n" +
            "                }}\n" +
            "                sx={{\n" +
            '                  "& input::-webkit-calendar-picker-indicator": {\n' +
            '                    width: "82%",\n' +
            '                    position: "absolute",\n' +
            '                    cursor: "pointer",\n' +
            "                    opacity: 0,\n" +
            "                    zIndex: 99,\n" +
            "                  },\n" +
            "                }}\n" +
            "            />"
          }
        >
          <TextField
            label={"Don't send any messages before"}
            type={"date"}
            // value="2023-08-27"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CalenderIcon fontSize={"small"} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& input::-webkit-calendar-picker-indicator": {
                width: "82%",
                position: "absolute",
                cursor: "pointer",
                opacity: 0,
                zIndex: 99,
              },
            }}
          />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default BasicDatePicker;
